export interface Consumer {
  $id: string;
  NameFirst: string;
  NameLast: string;
}
